module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('f7-page', {
    attrs: {
      "name": "recommendfriendHistory"
    }
  }, [_c('bc-navbar'), _vm._v(" "), _c('div', {
    staticClass: "page_single layout_fullwidth_padding"
  }, [_c('page-header', {
    attrs: {
      "title": _vm.title,
      "backUrl": _vm.backLink
    },
    scopedSlots: _vm._u([{
      key: "headerIcon",
      fn: function() {
        return [_c('img', {
          attrs: {
            "src": "/static/svg/referral.svg",
            "alt": "referral icon"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('p', {
    staticClass: "description"
  }, [_vm._v("\n     " + _vm._s(_vm.disclaimer) + "\n    ")]), _vm._v(" "), _c('section', [_c('features', {
    attrs: {
      "referralProgramType": _vm.referralProgramType
    }
  })], 1), _vm._v(" "), _c('section', {
    staticClass: "steps"
  }, _vm._l((_vm.steps), function(step, index) {
    return _c('div', {
      key: index,
      staticClass: "step"
    }, [_c('h3', [_vm._v(_vm._s(index + 1) + ". " + _vm._s(step.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(step.description))])])
  }), 0), _vm._v(" "), _c('section', {
    staticClass: "links"
  }, [_c('a', {
    staticClass: "link",
    attrs: {
      "href": _vm.termsLink
    }
  }, [_vm._v("Terms and Conditions")]), _vm._v(" "), _c('a', {
    staticClass: "link",
    attrs: {
      "href": _vm.policyLink
    }
  }, [_vm._v("Privacy Policy")])])], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-591f4579", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-591f4579"}!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/src/pages/referral-program/how-it-works.vue
// module id = 831
// module chunks = 0